import { render, staticRenderFns } from "./DropDownComment.vue?vue&type=template&id=2ab49bc8&"
import script from "./DropDownComment.vue?vue&type=script&lang=ts&"
export * from "./DropDownComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports